import initialState from "./marina.state.js";
import actions from "./marina.actions.js";
import mutations from "./marina.mutations.js";
import getters from "./marina.getters.js";

export default {
  state: initialState,
  actions,
  mutations,
  getters
};
